export default "__VITE_ASSET__CraQcyLt__"